import type { PrintJobServerTime } from '../types'

/**
 * Millis from a Firestore `Timestamp`-shaped value.
 * Returns null when the stamp is missing or unreadable.
 */
export function firestoreServerMillis(value: PrintJobServerTime | undefined): number | null {
  if (!value) return null
  if (typeof value.toMillis === 'function') {
    const ms = value.toMillis()
    return Number.isFinite(ms) ? ms : null
  }
  if (typeof value.seconds === 'number' && Number.isFinite(value.seconds)) {
    const nanos = typeof value.nanoseconds === 'number' ? value.nanoseconds : 0
    return value.seconds * 1000 + Math.floor(nanos / 1e6)
  }
  return null
}

export function medianNumber(values: number[]): number {
  const sorted = [...values].sort((a, b) => a - b)
  const mid = Math.floor(sorted.length / 2)
  if (sorted.length % 2 === 1) return sorted[mid] ?? 0
  return Math.round(((sorted[mid - 1] ?? 0) + (sorted[mid] ?? 0)) / 2)
}

/**
 * Server "now". Uses this tablet's clock-offset samples when present; otherwise
 * the latest fallback server millis; otherwise the wall clock.
 * Never `max` with wall clock.
 */
export function estimateServerNowMs(
  localOffsetSamples: readonly number[],
  fallbackServerMs: number | null,
  nowMs: number = Date.now(),
): number {
  if (localOffsetSamples.length > 0) return nowMs - medianNumber([...localOffsetSamples])
  if (fallbackServerMs !== null) return fallbackServerMs
  return nowMs
}
